import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Vehicle } from '../../types/vehicles';

export interface VehicleSliceInterface {
    value : Vehicle | null;
}

const initialState: VehicleSliceInterface = {
    /* 
        {
            "model": "atlas",
            "background": "#51000C",
            "fontColor": "#FFFFFF"
        }
    */

    value : null
}

export const vehicleSlice = createSlice({
    name : 'vehicle',
    initialState,
    reducers: {
        set: (state, action : PayloadAction<VehicleSliceInterface>) => {
            state.value = action.payload.value;
        }
    }
});

export const { set } = vehicleSlice.actions;

export default vehicleSlice.reducer;
